// @ts-strict-ignore
/**
 * Used as an inline react-hook-form resolver for Yup validation
 * https://github.com/react-hook-form/resolvers/blob/master/yup/src/yup.ts
 */
export const resolveYupRule = async (rule: any, v: any): Promise<any> => {
  try {
    await rule.validate(v, { abortEarly: false });
  } catch (e) {
    if (!e.inner) {
      throw e;
    }

    return e.message;
  }
};
